<template>
  <v-dialog :value="open" content-class="request-field-item-dialog" persistent>
    <v-card
      color="#f0f0ef"
      class="home-form-container"
      style="min-height: 180px; max-height: 600px; padding-top: 15px"
    >
      <v-card-text
        class="home-form-container"
        style="max-height: 600px; overflow-y: visible"
      >
        <div style="width: 100px; text-align: left">
          <label style="font-size: 14px; margin-right: 30px;">{{
            $tc("Add")
          }}</label>
        </div>

        <drop-file-area
          style="margin-top: 10px; max-height:400px"
          :style="dropFileAreaStyle"
          ref="dropFileArea"
          :disabled="false"
          :file-types="acceptedFileTypes"
          @updateFile="importFile = $event"
          @trashFile="importFile = null"
          :multipleFiles="allowMultipleFiles"
        />

        <slot name="formSlot1" />

        <v-card-actions style="padding: 20px 0 0 0">
          <v-spacer />
          <management-button
            type="cancel"
            :label="$t('Cancel')"
            @buttonClick="close"
          />
          <management-button
            type="execute"
            :label="$t('Create')"
            :disabled="submitButtonDisabled"
            @buttonClick="saveAttachment"
          />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ManagementButton from "@/components/Management/ManagementButton";
import DropFileArea from "@/components/_Molecules/DropFileArea";

export default {
  name: "AttachmentForm",

  components: { ManagementButton, DropFileArea },

  props: {
    open: {
      type: Boolean,
      required: true
    },

    allowMultipleFiles: {
      type: Boolean,
      default: true
    },

    acceptedFileTypes: {
      type: Array,
      required: false,
      default: [""]
    }
  },

  data() {
    return {
      importFile: null
    };
  },

  computed: {
    submitButtonDisabled() {
      return this.importFile === null;
    },

    multipleFiles() {
      return this.importFile !== null && this.importFile.length > 1
        ? true
        : false;
    },

    dropFileAreaStyle() {
      return this.multipleFiles ? "overflow-y: scroll" : "overflow-y: unset";
    }
  },

  methods: {
    async saveAttachment() {
      this.$emit("add-attachment", this.importFile);
      this.close();
    },

    close() {
      this.$emit("close");
      this.importFile = null;
      this.$refs.dropFileArea.trashFiles();
    }
  }
};
</script>

<style>
.request-field-item-dialog {
  overflow-y: visible;
  max-width: 600px;
  min-height: 175px !important;
  max-height: 600px;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Support/TechnicalSupport/AttachmentForm.vue